import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { ExternalLinkButtonBlockConfig } from '@front-platform/content-builder';
import { externalLinkButtonBlockResolveConfig } from '@front-platform/content-builder';
import { Component, ViewEncapsulation, input } from '@angular/core';

enum ExternalLinkButtonType {
  text = 'text',
  light = 'light',
  normal = 'normal',
  outlined = 'outlined',
}

enum ExternalLinkButtonLevel {
  primary = 'primary',
  secondary = 'secondary',
  neutral = 'neutral',
  info = 'info',
  success = 'success',
  error = 'error',
  highlight = 'highlight',
}

enum ExternalLinkButtonSize {
  small = 'sm',
  medium = 'md',
  large = 'lg',
  extraLarge = 'xl',
}

type ExternalLinkButtonTarget = '_blank' | '_self' | '_parent' | '_top' | string;
export interface ExternalLinkButtonBlockRuntimeConfig {
  'disabled'?: boolean;
  'content'?: unknown[];
}

export type ExternalLinkButtonBlockConfigInput = Partial<
  Omit<ExternalLinkButtonBlockConfig, keyof ExternalLinkButtonBlockRuntimeConfig> &
    ExternalLinkButtonBlockRuntimeConfig
>;
export type ExternalLinkButtonBlockResolvedConfig = Omit<
  ExternalLinkButtonBlockConfig,
  keyof ExternalLinkButtonBlockRuntimeConfig
> &
  Partial<ExternalLinkButtonBlockRuntimeConfig>;
export interface ExternalLinkButtonBlockContract extends ConfigComponentContract<
  ExternalLinkButtonBlockConfigInput,
  ExternalLinkButtonBlockResolvedConfig
> {}

@Component({
  selector: 'app-external-link-button-block',
  templateUrl: './external-link-button-block.component.html',
  styleUrls: ['./external-link-button-block.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ExternalLinkButtonBlockComponent implements ExternalLinkButtonBlockContract {
  readonly config = input<ExternalLinkButtonBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    ExternalLinkButtonBlockConfig,
    ExternalLinkButtonBlockRuntimeConfig
  >(externalLinkButtonBlockResolveConfig, () => ({ config: this.config() }));
  get url(): string | undefined {
    return this.resolvedConfig()['url'] as unknown as string | undefined;
  }
  get disabled(): boolean {
    return this.resolvedConfig()['disabled'] as unknown as boolean;
  }
  get content(): unknown[] {
    return this.resolvedConfig()['content'] as unknown as unknown[];
  }
  get target(): ExternalLinkButtonTarget {
    return this.resolvedConfig()['target'] as unknown as ExternalLinkButtonTarget;
  }
  get size(): ExternalLinkButtonSize {
    return this.resolvedConfig()['size'] as unknown as ExternalLinkButtonSize;
  }
  get type(): ExternalLinkButtonType {
    return this.resolvedConfig()['type'] as unknown as ExternalLinkButtonType;
  }
  get level(): ExternalLinkButtonLevel {
    return this.resolvedConfig()['level'] as unknown as ExternalLinkButtonLevel;
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(ExternalLinkButtonBlockComponent, {
  'keyAliases': {},
});
